import {DateString} from "./EntityFields";

export enum NotificationType {
	TAKE_MEDICINE= 'TAKE_MEDICINE',
	VIDEO_CALL_REQUEST= 'VIDEO_CALL_REQUEST',
	RECORD_SAVED= 'RECORD_SAVED',
	RECORD_SAVED_WARNING= 'RECORD_SAVED_WARNING',
	PATIENT_HIGH_RISK= 'PATIENT_HIGH_RISK',
}

export interface NotificationPayload {
	[key : string] : string
}

export interface NNotification {
	id: string;
	type: NotificationType;
	createdAt: DateString;
	payload?: NotificationPayload;
}
